import axios, { AxiosResponse } from 'axios';
import {
  CreatePartnerRequest,
  CreatePartnerResponse,
  UpdatePartnerRequest,
  PartnerListResponse,
  DeletePartnerResponse,
  ClearPartnersResponse,
  PartnerDto
} from './types';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const partnerApi = {
  // Create a new partner
  createPartner: async (request: CreatePartnerRequest): Promise<CreatePartnerResponse> => {
    const response = await apiClient.post<CreatePartnerResponse>('/protectpay/admin/partners', request);
    return response.data;
  },

  // Get all partners
  getAllPartners: async (): Promise<PartnerListResponse> => {
    const response = await apiClient.get<PartnerListResponse>('/protectpay/admin/partners');
    return response.data;
  },

  // Get a specific partner by ID
  getPartner: async (partnerId: string): Promise<{ partner: PartnerDto }> => {
    const response = await apiClient.get<PartnerDto>(`/protectpay/admin/partners/${partnerId}`);
    return { partner: response.data };
  },

  // Update an existing partner
  updatePartner: async (partnerId: string, request: UpdatePartnerRequest): Promise<CreatePartnerResponse> => {
    const response = await apiClient.put<CreatePartnerResponse>(`/protectpay/admin/partners/${partnerId}`, request);
    return response.data;
  },

  // Delete a partner
  deletePartner: async (partnerId: string): Promise<DeletePartnerResponse> => {
    const response = await apiClient.delete<DeletePartnerResponse>(`/protectpay/admin/partners/${partnerId}`);
    return response.data;
  },

  // Clear all partners (admin only)
  clearAllPartners: async (): Promise<ClearPartnersResponse> => {
    const response = await apiClient.delete<ClearPartnersResponse>('/protectpay/admin/partners/clear');
    return response.data;
  },
};
